import { render, staticRenderFns } from "./customer-tier-table.vue?vue&type=template&id=654fffa5&scoped=true"
import script from "./customer-tier-table.vue?vue&type=script&lang=js"
export * from "./customer-tier-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654fffa5",
  null
  
)

export default component.exports